import React from "react";
import mystioMap from "../../assets/mystio-map.png";

export default function MapSectionMystio() {
  return (
    <section className="w-full bg-[#B37D22] py-16 px-6 md:px-12 lg:px-20 text-black">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        {/* Left Side: Map image */}
        <div className="w-full md:w-1/2 flex justify-center items-center">
          <img
            src={mystioMap}
            alt="World Map Silhouette"
            className="w-full max-w-md object-contain hover:scale-105 transition-transform duration-500 drop-shadow-lg"
          />
        </div>

        {/* Right Side: Text & CTA */}
        <div className="w-full md:w-1/2 flex flex-col items-start text-left">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-oswald text-black tracking-wide uppercase mb-4">
            LOREM IPSUM IS SIMPLY DUMMY
          </h2>

          <p className="text-black/90 font-outfit text-sm sm:text-base leading-relaxed mb-8 max-w-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
          </p>

          <button className="px-8 py-3 bg-transparent border-2 border-white text-white font-bold font-outfit uppercase tracking-widest text-sm hover:bg-white hover:text-black transition-all duration-300 rounded-md active:scale-95 outline-none focus:outline-none">
            Track Now
          </button>
        </div>
      </div>
    </section>
  );
}
